import {Toast} from 'vant'
import { api } from '../config/index.js'
export function verification(objArray,hintArray){
    for(let i=0;i<hintArray.length;i++){
        if(objArray[hintArray[i].id]===''||objArray[hintArray[i].id]===null||objArray[hintArray[i].id]===undefined){
             Toast(hintArray[i].name);
             return false;
        }
    }
    return true;
}

/**
 * 校验链接后缀类型（图片、PDF或其他）
 * @param {string} link - 需要校验的链接或文件名
 * @returns {string} 'image' - 图片类型, 'pdf' - PDF类型, 'other' - 其他类型
 */
export function checkLinkInFileType(link) {
    if (typeof link !== 'string') {
        return 'other'; // 非字符串直接返回其他类型
    }
    // 常见图片格式后缀（不区分大小写）
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff'];
    // PDF格式后缀
    const pdfExtension = 'pdf';
    
    // 提取链接中的后缀（忽略参数和哈希值）
    const cleanedLink = link.split('?')[0].split('#')[0]; // 去除URL中的查询参数和哈希
    const lastDotIndex = cleanedLink.lastIndexOf('.');
    
    // 没有后缀的情况
    if (lastDotIndex === -1 || lastDotIndex === cleanedLink.length - 1) {
        return 'other';
    }
    
    // 获取后缀并转为小写
    const extension = cleanedLink.slice(lastDotIndex + 1).toLowerCase();
    
    // 检查是否为图片类型
    if (imageExtensions.includes(extension)) {
        return 'image';
    }
    // 检查是否为PDF类型
    if (extension === pdfExtension) {
        return 'pdf';
    }
    
    // 其他类型
    return 'other';
}

// // 测试示例
// console.log(checkLinkType('a55.jpeg')); // 输出: 'image'
// console.log(checkLinkType('document.pdf')); // 输出: 'pdf'
// console.log(checkLinkType('image.PNG')); // 输出: 'image'（不区分大小写）
// console.log(checkLinkType('file.docx')); // 输出: 'other'
// console.log(checkLinkType('https://example.com/photo.jpg?width=100')); // 输出: 'image'（忽略URL参数）
// console.log(checkLinkType('data/image.gif#section1')); // 输出: 'image'（忽略哈希值）


/**
 * 格式化文件路径字符串
 * @param {string} path - 需要格式化的路径字符串
 * @returns {string} 格式化后的路径字符串
 */
export function formatFilePath(path) {
    if (typeof path !== 'string') {
        // 处理非字符串输入
        return '';
    }
    // 步骤1：去掉开头的~
    let formatted = path.startsWith('~') ? path.slice(1) : path;
    
    // 步骤2：将\\替换为/
    formatted = formatted.replace(/\\\\/g, '/');
    
    return api.fileServer+'/'+formatted;
}


//////////////////
// WEBPACK FOOTER
// ./tool/verification.js
// module id = null
// module chunks = 